import { Grid } from '@material-ui/core'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import { useStyles } from '../styles'
import TableSegmentsMarketShare from '../../Tables/TableSegmentsMarketShare'

const TotalEasyToHandleByTerritoryCard = props => {
  const { zonesByTerritory = [], selectedDate } = props
  const classes = useStyles()

  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Total fáciles de manejar por zonas</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={12}>
            <TableSegmentsMarketShare
              array={zonesByTerritory}
              selectedDate={selectedDate}
              sizeHeader='3'
              enableDate
              param="EMPRESA"
              order="TERRITORIO"
            />
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default TotalEasyToHandleByTerritoryCard
